export default "__VITE_PUBLIC_ASSET__13bf0ae5__"